import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import styled from 'styled-components';
import { TextWithGradient } from '../../VuexyDesign/atoms/Text';
import { Col, Row } from '../../VuexyDesign/atoms/_index';
import { noDesktop, useIsDesktop } from '../../style/constants';
import DistributionButton from './DistributionButton';

function DistributeMusicYourTerms() {
  const isDesktop = useIsDesktop();
  const { t } = useTranslation('distributionLanding');
  const getButton = () => (
    <DistributionButton
      type="GRADIENT_FILLED"
      text={t('distributionLanding:distributeMusicButton') as string}
    />
  );

  return (
    <RowContainer>
      <Col md={6} className="mb-2 mb-md-0">
        <div className="platform-distribute-music">
          <div className="mr-1">
            <TextWithGradient>
              {
                t(
                  'distributionLanding:distributeMusicYourTerms.noOnePlatform',
                ) as string
              }
            </TextWithGradient>
          </div>
        </div>
        <h1 className="custom-heading-font-1 text-center-mobile">
          {t('distributionLanding:distributeMusicYourTerms.title') as string}
        </h1>

        <div className="monetize-music-subtitle">
          <p className="custom-font-text-medium-normal paragraph-color">
            {
              t(
                'distributionLanding:distributeMusicYourTerms.subTitle',
              ) as string
            }
          </p>
        </div>

        <div className="d-flex flex-column flex-md-row align-items-md-center mt-2 distribution-button">
          {getButton()}
        </div>
      </Col>
      <Col md={6} className="d-flex justify-content-center">
        <div className="d-flex align-items-center image-distribution-landing">
          <Image
            priority
            fetchPriority="high"
            src={`${
              !isDesktop
                ? '/static/images/distribution-landing/photo-atf-logged-in-mobile.webp'
                : '/static/images/distribution-landing/photo-atf-logged-in.png'
            }`}
            width={!isDesktop ? 386 : 671}
            height={!isDesktop ? 420 : 700}
            className="pointer-events-none"
            alt="Music distribution"
          />
        </div>
      </Col>
    </RowContainer>
  );
}

const RowContainer = styled(Row)`
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  width: 75%;
  .platform-distribute-music {
    display: flex;
    align-items: center;
  }

  .monetize-music-subtitle {
    width: 75%;
  }
  .image-distribution-landing {
    height: 50rem;
  }

  @media ${noDesktop} {
    width: 100%;
    flex-direction: column-reverse;

    .distribution-button {
      justify-content: center;
    }
    .monetize-music-subtitle {
      text-align: center;
      margin-left: auto;
      margin-right: auto;
      width: 100%;
    }
    .platform-distribute-music {
      justify-content: center;
    }
    .image-distribution-landing {
      height: 30rem;
    }
  }

  .text-center-mobile {
    @media ${noDesktop} {
      text-align: center;
    }
  }
`;

export default DistributeMusicYourTerms;
